import React, { useState, useEffect } from "react";

function FileUpload({ id, title, handleFileChange, existingFile }) {
  const [fileName, setFileName] = useState(existingFile ? existingFile.name : null);

  useEffect(() => {
    if (existingFile && existingFile.name !== fileName) {
      setFileName(existingFile.name);
    }
  }, [existingFile]);

  function onFileChange(e) {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      handleFileChange(e);
    }
  }

  function getTruncatedFileName(name) {
    if (name.length > 10) {
      return name.substring(0, 10) + "...";
    }
    return name;
  }

  return (
    <fieldset>
      <label
        htmlFor={id}
        className="flex text-[#1D2639] text-base font-normal justify-center text-left items-center"
      >
        {title}
      </label>

      <input
        type="file"
        id={id}
        name={id}
        className="hidden"
        onChange={onFileChange}
      />

      {fileName ? (
        <label
          htmlFor={id}
          className="cursor-pointer flex items-center gap-1 w-full h-9 px-2 py-1 bg-[#F9F9F9] rounded-lg text-gray-500 text-center justify-start"
        >
          {/* SVG icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
          >
            <path
              d="M4.66536 14.5C4.31174 14.5 3.9726 14.3595 3.72256 14.1095C3.47251 13.8594 3.33203 13.5203 3.33203 13.1667V2.5H9.33203L12.6654 5.83333V13.1667C12.6654 13.5203 12.5249 13.8594 12.2748 14.1095C12.0248 14.3595 11.6857 14.5 11.332 14.5H4.66536Z"
              stroke="#7E7E7E"
              strokeWidth="1.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.66406 2.5V6.5H12.6641"
              stroke="#7E7E7E"
              strokeWidth="1.33333"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-gray-700">{getTruncatedFileName(fileName)}</span>
        </label>
      ) : (
        <label
          htmlFor={id}
          className="cursor-pointer flex items-center gap-1 w-full h-9 px-2 py-1 bg-[#F9F9F9] rounded-lg text-gray-500 text-center justify-start"
        >
          {/* SVG icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
          >
            <path
              d="M4.66536 14.5C4.31174 14.5 3.9726 14.3595 3.72256 14.1095C3.47251 13.8594 3.33203 13.5203 3.33203 13.1667V2.5H9.33203L12.6654 5.83333V13.1667C12.6654 13.5203 12.5249 13.8594 12.2748 14.1095C12.0248 14.3595 11.6857 14.5 11.332 14.5H4.66536Z"
              stroke="#7E7E7E"
              strokeWidth="1.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.66406 2.5V6.5H12.6641"
              stroke="#7E7E7E"
              strokeWidth="1.33333"
              strokeLinejoin="round"
            />
          </svg>
          Upload File
        </label>
      )}
    </fieldset>
  );
}

export default FileUpload;
